import React, { useState, useEffect } from 'react';
import TextInput from './TextInput';

function MultipleChoice({ question, value = {}, onChange }) {
  const [selectedValue, setSelectedValue] = useState(value.main || '');
  const [conditionalAnswers, setConditionalAnswers] = useState(value.conditional || {});

  // Update local state when value prop changes (new question)
  useEffect(() => {
    setSelectedValue(value.main || '');
    setConditionalAnswers(value.conditional || {});
  }, [value, question.id]);

  const handleSelectionChange = (optionValue) => {
    setSelectedValue(optionValue);
    
    // Clear conditional answers if switching to different option
    if (optionValue !== selectedValue) {
      setConditionalAnswers({});
    }
    
    const newValue = {
      main: optionValue,
      conditional: optionValue === selectedValue ? conditionalAnswers : {}
    };
    onChange(newValue);
  };

  const handleConditionalChange = (conditionalValue, nestedPath = '') => {
    const newConditionalAnswers = { ...conditionalAnswers };
    if (nestedPath) {
      newConditionalAnswers[nestedPath] = conditionalValue;
    } else {
      newConditionalAnswers.main = conditionalValue;
    }
    
    setConditionalAnswers(newConditionalAnswers);
    
    const newValue = {
      main: selectedValue,
      conditional: newConditionalAnswers
    };
    onChange(newValue);
  };


  const renderConditionalInput = (conditional, path = '') => {
    if (conditional.type === 'text') {
      const conditionalQuestion = {
        text: conditional.text,
        placeholder: conditional.placeholder
      };
      
      return (
        <div className="conditional-input" key={path}>
          <TextInput
            question={conditionalQuestion}
            value={conditionalAnswers[path || 'main'] || ''}
            onChange={(value) => handleConditionalChange(value, path || 'main')}
          />
        </div>
      );
    } else if (conditional.type === 'multiple_choice') {
      const conditionalQuestion = {
        text: conditional.text,
        options: conditional.options
      };
      
      return (
        <div className="conditional-input" key={path}>
          <MultipleChoice
            question={conditionalQuestion}
            value={conditionalAnswers[path || 'main'] || {}}
            onChange={(value) => handleConditionalChange(value, path || 'main')}
          />
        </div>
      );
    }
    
    return null;
  };

  return (
    <div className="multiple-choice">
      <h3>{question.text}</h3>
      {question.description && <p className="question-description">{question.description}</p>}
      
      {question.definition && (
        <div className="definition-box">
          <strong>Definition:</strong> {question.definition}
        </div>
      )}
      
      {question.risks && (
        <div className="risks-box">
          <strong>Risks:</strong> {question.risks}
        </div>
      )}
      
      <div className="options-list">
        {question.options.map((option) => (
          <div key={option.value} className="option-item">
            <label className="option-label">
              <input
                type="radio"
                name={question.id}
                value={option.value}
                checked={selectedValue === option.value}
                onChange={() => handleSelectionChange(option.value)}
              />
              <span className="option-text">{option.text}</span>
            </label>
            
            {selectedValue === option.value && option.conditional && (
              <div className="conditional-section">
                {renderConditionalInput(option.conditional)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MultipleChoice;